export default {
  'status': 'Translation validated by country',
  'meta': {
    'lang': 'Italiano'
  },
  'title': 'RICHIAMO DEL PRODOTTO QUICKDRAWS SIMOND ALPINISM / VERTIKA',
  'homepage': {
    'notice': 'Richiamo prodotto. Informazioni importanti sulla vostra sicurezza e sull\'attrezzatura.',
    'purchaseWindow': 'Avete acquistato un rinvio da arrampicata ALPINISM e/o VERTIKA tra il 1° gennaio 2022 e il 23 luglio 2026.',
    'skus': 'Rinvio Alpinism 11 cm (4051175 / 8589547)\nRinvio Alpinism 17 cm (4051176 / 8589548)\nConfezione da 5 rinvii Alpinism (4171656 / 8608405)\nRinvio Vertika 11 cm (5499689 / 8935765)\nRinvio Vertika 17 cm (5500194 / 8935909)',
    'responsibility': 'La progettazione di dispositivi di protezione individuale implica la massima responsabilità nei confronti di chi utilizza i nostri prodotti. Pertanto, vi informiamo del richiamo di un rinvio dotato di moschettone Rocky Fil.',
    'defect': 'Abbiamo riscontrato un difetto nella rivettatura del fermo del moschettone su alcuni moschettoni. Questo difetto di assemblaggio può causare la rottura del fermo e comportare il rischio di rottura del moschettone in caso di caduta.',
    'stopUsing': 'A titolo precauzionale, vi preghiamo di interrompere immediatamente l\'utilizzo del prodotto e di seguire la procedura descritta di seguito.'
  },
  'procedure': {
    'stopUsing': 'Vi preghiamo di verificare se il vostro prodotto presenta questo difetto seguendo le istruzioni per la risoluzione dei problemi riportate di seguito.',
    'title': 'Come verificare il vostro prodotto:',
    'intro': 'Verificate che entrambi i lati del fermo a filo rimangano saldamente fissati al moschettone:',
    'step1': 'Prendete il moschettone da un lato, posizionate il pollice tra i due fili (il pollice più vicino al rivetto). Premete con decisione verso il basso sul moschettone.',
    'step2': 'Capovolgete il moschettone e ripetete la stessa operazione sull\'altro lato del fermo a filo.'
  },
  'outcome': {
    'nok': {
      'body': 'Se dopo l\'ispezione il filo si è allentato: si prega di interrompere immediatamente l\'utilizzo del prodotto e di restituirlo al punto vendita DECATHLON più vicino. Riceverete un rimborso completo per gli articoli difettosi.',
      'support': 'In caso di difficoltà, il nostro Servizio Clienti è a disposizione al seguente https://www.decathlon.it/help per  guidarvi nella procedura.'
    },
    'ok': {
      'body': 'Se dopo aver fatto la verifica, il filo non fuoriesce dal suo alloggiamento, allora il prodotto non è interessato da questo difetto e puoi continuare a utilizzarlo in tutta tranquillità.'
    }
  },
  'buttons': {
    'ok': 'Il mio prodotto è OK',
    'nok': 'Il mio prodotto è NOK'
  }
} as const
